// import React from "react";
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModelViewbox from "../modelViewbox";
// import LoginComponent from '../components/login-registration/loginComponent';

function IgnitePanel(props) {

    return (
        <div >
            <h1
                // align={!isMobile ? "left" : "center"}
                align="center"
                style={{ padding: "1%", fontSize: "42px", color: "#5a5a5a" }}
            >
                Ignite Your Potential.
            </h1>
            <Row>
                {!props.isMobile ? (
                    <Col>
                        <ModelViewbox src={"https://storage.googleapis.com/interactive-structures/protein-viewer/index_hp_final.html?model=objects/ATP-Synthase-10&scale=0.19&colors=[9B9EFE,018502,C1A37D,0001FB,8B0486,6262F8,FEFF85,056802,FF6201,FEC702,00BE00,ffffff]"} />
                    </Col>
                ) : (
                    <></>
                )}
                <Col>
                    {/* <h2 style={{ fontWeight: "bold" }}>The Smart Biology Way</h2>
								<br></br> */}
                    <Row>
                        <div className="grid-container">
                            <div
                                className="story-card"
                                style={{
                                    padding: "20px",
                                    borderRadius: "20px",
                                    backgroundColor: "white",
                                }}
                            >
                                <div>
                                    <h3
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: 42,
                                            textAlign: "left",
                                            color: "#054bb4",
                                        }}
                                    >
                                        Your Choice
                                    </h3>
                                    <p>
                                        Instructor customization for Classroom and Student
                                        choices for Academy.
                                    </p>
                                </div>
                            </div>
                            <div style={{ gridRow: "span 2 / auto" }}>
                                <div
                                    className="story-card"
                                    style={{
                                        padding: "20px",
                                        borderRadius: "20px",
                                        backgroundColor: "white",
                                    }}
                                >
                                    <div>
                                        <h3
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: 42,
                                                textAlign: "left",
                                                color: "#054bb4",
                                            }}
                                        >
                                            Unique Approach
                                        </h3>
                                        <p>
                                            We integrate data to show students both the fine
                                            details and the big picture, with continuity between
                                            disciplines.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="story-card"
                                style={{
                                    padding: "20px",
                                    borderRadius: "20px",
                                    backgroundColor: "white",
                                }}
                            >
                                <div>
                                    <h3
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: 42,
                                            textAlign: "left",
                                            color: "#054bb4",
                                        }}
                                    >
                                        Class Tools
                                    </h3>
                                    <p>
                                        LMS integration, instructor resources, online notes,
                                        quizzes, and more.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Col>
            </Row>
        </div>
    );



    //   const [userName, setUserName] = useState({});
    //   const [userId, setUserId] = useState({});

    //   useEffect(() => {
    //     setUserDetails();
    //   }, []);

    //   const setUserDetails = async () => {
    //     setUserName('john');
    //     setUserId('1234');
    //   }

    //   return (
    //     <div >
    //       <Container>
    //         <Row>
    //           <Col md={{ span: 6, offset: 3 }}>
    //             <LoginComponent />

    //           </Col>
    //         </Row>
    //       </Container>
    //     </div>
    //   );
}

export default IgnitePanel;